import react from "react";
import Viewer from "../components/Viewer";
import { Machines } from "../graphql/querys/machines";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Machine } from "../graphql/querys/machine";
export default function MachinesScreen() {
	return <Viewer viewerInfo="machines" viewerQueryAll={Machines}></Viewer>;
}
